import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { ReasonService } from '@app/services/reason.service';
import { SettingService } from '@app/services/setting.service';
import { ToastService } from '@app/services/toast.service';
import { Observable, forkJoin } from 'rxjs';
import { BreadcrumbService } from '@app/services/breadcrumb.service';
import { Router } from '@angular/router';
interface Admin {
  id: number;
  name: string;
  hasPermission: boolean;
}

interface NotificationSettings {
  successful: boolean;
  unsuccessful: boolean;
  cancelled: boolean;
}

interface EmailSettings {
  enroute: boolean;
  shipped: boolean;
  successful: boolean;
  unsuccessful: boolean;
  cancelled: boolean;
}

interface SMSSettings {
  enroute: boolean;
  shipped: boolean;
}

interface SettingsData {
  archiveOrders: number;
  clearNotifications: number;
  departureTime: string;
  pushNotifications: NotificationSettings;
  emailNotifications: EmailSettings;
  smsNotifications: SMSSettings;
  permissions: { [key: number]: boolean };
}

interface Reason {
  id: number;
  description: string;
  category: string;
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SettingsComponent implements OnInit {
  // Tab Management
  activeTab: "general" | "reasons" = "general";

  // Reason Tab Management
  activeReasonType: 'unsuccessful' | 'cancelled' = 'unsuccessful';

  // Settings State
  archiveOrders: any;
  clearNotifications: number = 0;
  departureTime: string = '06:00';

  // Notification Settings
  pushNotifications: NotificationSettings = {
    successful: false,
    unsuccessful: false,
    cancelled: false
  };

  emailNotifications: EmailSettings = {
    enroute: false,
    shipped: false,
    successful: false,
    unsuccessful: false,
    cancelled: false
  };

  smsNotifications: SMSSettings = {
    enroute: false,
    shipped: false
  };

  // Admin Permissions
  admins: any;

  // Reasons
  reasons: any;

  filteredReasons: Reason[] = [];
  searchQuery: string = '';

  // Pagination
  currentPage: number = 1;
  totalPages: number = 1;
  itemsPerPage: number = 10;

  // Modal
  showReasonModal: boolean = false;
  reasonForm!: FormGroup;
  editingReasonId: number | null = null;

  // Counts
  unsuccessfulCount: number = 0;
  cancelCount: number = 0;

  constructor(
    private fb: FormBuilder, public authService: AuthServiceService, public reason: ReasonService, public settingService: SettingService, private toast: ToastService, private dialogService: DialogService, private breadcrumbService: BreadcrumbService, private router: Router
  ) { }

  _isRoleName: any;
  isLoading: boolean = false;
  showadminsblock: boolean = false;
  shippingEnrouteEmailRec: any;
  ShippingShippedEmailRec: any;
  ShippingSuccessfullEmailRec: any;
  ShippingUnSuccessfullEmailRec: any;
  ShippingCancelledEmailRec: any;
  shippingEnrouteSmsRec: any;
  shippingShippedSmsRec: any;
  settings: any;
  succssfull: any;
  unsuccssfull: any;
  cancelled: any;
  clear_notifi_month: any;
  data: any;
  receiving_successful: any;
  receiving_unsuccessful: any;
  receiving_cancelled: any;
  receiving_clear_noti_after: any;
  ngOnInit(): void {
    this._isRoleName = this.authService._isRoleName;
    const isReceivingSide = this._isRoleName === 'reciver-admin' || this._isRoleName === 'receiving-admin' || this.router.url.includes('/receiving-admin');

    this.breadcrumbService.set([
      { 
        label: 'Dashboard', 
        icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', 
        action: () => this.router.navigate([isReceivingSide ? '/receiving-admin/dashboard' : '/admin/dashboard']) 
      },
      { label: 'Settings' }
    ]);
    const isSuperuser = localStorage.getItem('is_superuser') === 'true';
    const isStaff = localStorage.getItem('is_staff') === 'true';

    if (this._isRoleName == "reciver-admin" || this._isRoleName == "receiving-admin") {
      if (isSuperuser && isStaff) {
        this.showadminsblock = true;
      } else {
        this.showadminsblock = false;
      }
      //for clear notification and recive notification
      this.settingService.getSetting().subscribe(
        data => {
          console.log(data);
          this.settings = data.result;
          if (this.settings?.length <= 0) {
            this.recivingpostData();
          }

          this.pushNotifications.successful = this.settings?.[0]?.receiving_successful;
          this.pushNotifications.unsuccessful = this.settings?.[0]?.receiving_unsuccessful;
          this.pushNotifications.cancelled = this.settings?.[0]?.receiving_cancelled;
          this.clearNotifications = this.settings?.[0]?.receiving_clear_noti_after;
          this.succssfull = this.settings?.[0]?.succssfull;
          this.unsuccssfull = this.settings?.[0]?.unsuccssfull;
          this.cancelled = this.settings?.[0]?.cancelled;
          this.clear_notifi_month = this.settings?.[0]?.clear_notifi_month;
        },
        error => {
          console.error('Error:', error);

        }
      );
      // for email setting 
      this.settingService.emailgetSetting().subscribe(
        data => {
          console.log(data);
          this.settings = data.result;
          if (this.settings?.length <= 0) {
            this.recivingpostData();
          }

          this.emailNotifications.enroute = this.settings?.[0]?.receiving_enroute;
          this.emailNotifications.shipped = this.settings?.[0]?.receiving_shipped;
          this.emailNotifications.successful = this.settings?.[0]?.receiving_successful;
          this.emailNotifications.unsuccessful = this.settings?.[0]?.receiving_unsuccessful;
          this.emailNotifications.cancelled = this.settings?.[0]?.receiving_cancelled;
          this.shippingEnrouteEmailRec = this.settings?.[0]?.enroute;
          this.ShippingShippedEmailRec = this.settings?.[0]?.shipped;
          this.ShippingSuccessfullEmailRec = this.settings?.[0]?.successfull;
          this.ShippingUnSuccessfullEmailRec = this.settings?.[0]?.unsuccessfull;
          this.ShippingCancelledEmailRec = this.settings[0]?.cancelled;
        },
        error => {
          console.error('Error:', error);

        }
      );

      // for sms setting
      this.settingService.smsgetSetting().subscribe(
        data => {
          console.log(data);
          this.settings = data.result;
          if (this.settings?.length <= 0) {
            this.recivingpostData();
          }

          this.smsNotifications.enroute = this.settings?.[0]?.receiving_enroute;
          this.smsNotifications.shipped = this.settings?.[0]?.receiving_shipped;
          this.shippingEnrouteSmsRec = this.settings?.[0]?.enroute
          this.shippingShippedSmsRec = this.settings?.[0]?.shipped
        },
        error => {
          console.error('Error:', error);

        }
      );
    }
    else if (this._isRoleName == "admin") {
      this.getadmincontol();
      if (isSuperuser && isStaff) {
        this.showadminsblock = true;
      } else {
        this.showadminsblock = false;
      }
      this.loadAdminSettings();
    }

    this.initializeReasonForm();
  }

  initializeReasonForm(): void {
    this.reasonForm = this.fb.group({
      description: ['', Validators.required],
      category: ['', Validators.required]
    });
  }
  recivingpostData() {
    if (this._isRoleName == 'receiving-admin') {
      this.data = {
        receiving_successful: 'False',
        receiving_unsuccessful: 'False',
        receiving_cancelled: 'False',
        receiving_clear_noti_after: 1
      }
    }
    this.settingService.addSetting(this.data).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }
        this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  loadSettings(): void {
    // this.settingsService.getSettings().subscribe(
    //   (data) => {
    //     this.archiveOrders = data.archiveOrders;
    //     this.clearNotifications = data.clearNotifications;
    //     this.departureTime = data.departureTime;
    //     this.pushNotifications = data.pushNotifications;
    //     this.emailNotifications = data.emailNotifications;
    //     this.smsNotifications = data.smsNotifications;

    //     // Load admin permissions
    //     this.admins.forEach(admin => {
    //       admin.hasPermission = data.permissions[admin.id] || false;
    //     });
    //   },
    //   (error) => {
    //     console.error('Error loading settings:', error);
    //   }
    // );
  }

  // Tab Switching
  switchTab(tab: 'general' | 'reasons'): void {
    this.activeTab = tab;
    if (tab === 'reasons') {
      this.loadReasons();
    }
  }

  // Archive Orders
  selectArchiveOption(option: any): void {
    if (!this.showadminsblock) {
      this.toast.show('warning', "You don't have permission to edit archive settings");
      return;
    }
    if (this.archiveOrders === option) {
      this.archiveOrders = null;        // same option -> deactivate
    } else {
      this.archiveOrders = option;      // new option -> activate
    }
    this.updatedArchives(this.archiveOrders);
  }
  updatedArchives(values: any) {
    this.selectedDates = this.selectedDates === values ? null : values;

    if (this.selectedDates == 4) return;

    const data = {
      archive_interval: this.selectedDates,
      archive_start_date: null,
      archive_end_date: null,
    };

    this.settingService.archivesettingEdit(data).subscribe(
      (res: any) => {
        if (this.authService.resultCodeError(res)) {
          this.loadAdminSettings();
          // ❌ pehle initializeData call mat karo
          return;
        }

        this.toast.show('success', res?.resultDescription || (typeof res?.result === 'string' ? res?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }

  // Clear Notifications
  selectClearOption(option: any): void {
    if (!this.showadminsblock) {
      this.toast.show('warning', "You don't have permission to edit notification settings");
      return;
    }
    if (this.clearNotifications === option) {
      this.clearNotifications = 0;   // same button dubara click -> inactive
    } else {
      this.clearNotifications = option; // new button -> active
    }
    if (this._isRoleName == 'receiving-admin') {
      this.recivingPutData();
    }
    if (this._isRoleName == 'admin') {
      this.putData();
    }
  }
  recivingPutData() {
    const data = {
      month: this.settings?.[0]?.clear_notifi_month || 0,
      receiving_successful: this.pushNotifications.successful,
      receiving_unsuccessful: this.pushNotifications.unsuccessful,
      receiving_cancelled: this.pushNotifications.cancelled,
      receiving_clear_noti_after: this.clearNotifications || 0,
      sucessfull: this.succssfull,
      unsucessfull: this.unsuccssfull,
      cancelled: this.cancelled,
      clear_notifi_month: this.clear_notifi_month
    }
    this.settingService.settingEdit(data).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          this.loadAdminSettings();
          return;
        }
        this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  // Departure Time
  onDepartureTimeChange(time: string): void {
    this.departureTime = time;
    this.saveSettings();
  }

  // Toggle Notifications
  togglePushNotification(type: keyof NotificationSettings, event: any): void {
    if (!this.showadminsblock) {
      this.toast.show('warning', "You don't have permission to edit notification settings");
      event.target.checked = this.pushNotifications[type];
      return;
    }
    this.pushNotifications[type] = !this.pushNotifications[type];
    if (this._isRoleName == 'receiving-admin') {
      this.recivingPutData();
    }
    if (this._isRoleName == 'admin') {
      this.putData();
    }
  }
  toggleSignatureRequired(event: any) {
    if (!this.showadminsblock) {
      this.toast.show('warning', "You don't have permission to edit signature settings");
      event.target.checked = this.require_delivery_signature;
      return;
    }
    const isChecked = event.target.checked;

    // UI update
    this.require_delivery_signature = isChecked;

    const formData = new FormData();
    formData.append('require_delivery_signature', isChecked);

    this.settingService.updateDepartureTime(formData).subscribe({
      next: (res: any) => {
        console.log('Updated successfully', res);
        if (this.authService.resultCodeError(res)) {
          this.require_delivery_signature = !isChecked;
          return;
        }
        this.toast.show('success', res?.resultDescription);
        if (res?.result?.require_delivery_signature !== undefined) {
          localStorage.setItem('require_delivery_signature', res.result.require_delivery_signature);
        }
      },
      error: () => {
        // ❌ agar API fail ho to revert
        this.require_delivery_signature = !isChecked;
      }
    });
  }
  putData() {
    const data = {
      sucessfull: this.pushNotifications.successful,
      unsucessfull: this.pushNotifications.unsuccessful,
      cancelled: this.pushNotifications.cancelled,
      month: this.clearNotifications,
      receiving_successful: this.receiving_successful,
      receiving_unsuccessful: this.receiving_unsuccessful,
      receiving_cancelled: this.receiving_cancelled,
      receiving_clear_noti_after: this.receiving_clear_noti_after
    };
    this.settingService.settingEdit(data).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          this.loadAdminSettings();
          return;
        }

        this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }

  toggleEmailNotification(type: keyof EmailSettings, event: any): void {
    if (!this.showadminsblock) {
      this.toast.show('warning', "You don't have permission to edit notification settings");
      event.target.checked = this.emailNotifications[type];
      return;
    }
    this.emailNotifications[type] = !this.emailNotifications[type];
    if (this._isRoleName == 'receiving-admin') {
      this.recevingEmailputData();
    }
    if (this._isRoleName == 'admin') {
      this.emailputData();
    }

  }
  emailputData() {
    let companyid = localStorage.getItem('org_Id');
    const data = {
      company_id: companyid,
      enroute: this.emailNotifications.enroute,
      shipped: this.emailNotifications.shipped,
      successfull: this.emailNotifications.successful,
      unsuccessfull: this.emailNotifications.unsuccessful,
      cancelled: this.emailNotifications.cancelled
    };
    this.settingService.emailsettingEdit(data).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          this.loadAdminSettings();
          return;
        }

        this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  recevingEmailputData() {
    let companyid = localStorage.getItem('org_Id');
    const data = {
      company_id: companyid,
      receiving_enroute: this.emailNotifications.enroute,
      receiving_shipped: this.emailNotifications.shipped,
      receiving_successful: this.emailNotifications.successful,
      receiving_unsuccessful: this.emailNotifications.unsuccessful,
      receiving_cancelled: this.emailNotifications.cancelled,
      successfull: this.ShippingUnSuccessfullEmailRec,
      unsuccessfull: this.ShippingUnSuccessfullEmailRec,
      cancelled: this.ShippingCancelledEmailRec,
      enroute: this.shippingEnrouteEmailRec,
      shipped: this.ShippingShippedEmailRec
    };
    this.settingService.emailsettingEdit(data).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          this.loadAdminSettings();
          return;
        }

        this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  toggleSMSNotification(type: keyof SMSSettings, event: any): void {
    if (!this.showadminsblock) {
      this.toast.show('warning', "You don't have permission to edit notification settings");
      event.target.checked = this.smsNotifications[type];
      return;
    }
    this.smsNotifications[type] = !this.smsNotifications[type];
    if (this._isRoleName == 'receiving-admin') {
      this.receivingsmsputDatas();
    }
    if (this._isRoleName == 'admin') {
      this.smsputDatas();
    }
  }

  smsputDatas() {
    const companyid = localStorage.getItem('org_Id');

    const data = {
      company_id: companyid,
      enroute: this.smsNotifications.enroute,
      shipped: this.smsNotifications.shipped
    };

    this.settingService.smssettingEdit(data).subscribe(
      (response: any) => {
        if (this.authService.resultCodeError(response)) {
          this.loadAdminSettings();
          return;
        }

        this.toast.show('success', response?.resultDescription || (typeof response?.result === 'string' ? response?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  receivingsmsputDatas() {
    const companyid = localStorage.getItem('org_Id');

    const data = {
      company_id: companyid,
      receiving_enroute: this.smsNotifications.enroute,
      receiving_shipped: this.smsNotifications.shipped,
      enroute: this.shippingEnrouteSmsRec,
      shipped: this.shippingShippedSmsRec,
    };

    this.settingService.smssettingEdit(data).subscribe(
      (response: any) => {
        if (this.authService.resultCodeError(response)) {
          this.loadAdminSettings();
          return;
        }

        this.toast.show('success', response?.resultDescription || (typeof response?.result === 'string' ? response?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  // Admin Permissions
  toggleAdminPermission(admin: any, event: any): void {
    admin.can_change_settings = event.target.checked;

    const id = admin.id;
    this.onCheckboxChangess(id, admin.can_change_settings);
  }

  onCheckboxChangess(id: number, admin: boolean) {
    const formData = new FormData();
    formData.append('can_edit', admin ? 'True' : 'False');

    this.settingService.adminsettingupdate(id, formData).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        this.toast.show('success', data?.resultDescription);
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  // Save Settings
  saveSettings(): void {
    const settings: SettingsData = {
      archiveOrders: this.archiveOrders,
      clearNotifications: this.clearNotifications,
      departureTime: this.departureTime,
      pushNotifications: this.pushNotifications,
      emailNotifications: this.emailNotifications,
      smsNotifications: this.smsNotifications,
      permissions: this.admins.reduce((acc: { [x: string]: any; }, admin: { id: string | number; hasPermission: any; }) => {
        acc[admin.id] = admin.hasPermission;
        return acc;
      }, {} as { [key: number]: boolean })
    };

    // this.settingsService.saveSettings(settings).subscribe(
    //   (response) => {
    //     console.log('Settings saved:', response);
    //   },
    //   (error) => {
    //     console.error('Error saving settings:', error);
    //   }
    // );
  }

  // Reasons Management
  switchReasonType(type: 'unsuccessful' | 'cancelled'): void {
    this.activeReasonType = type;
    this.loadReasons();
  }

  loadReasons(): void {
    this.countList();
    if (this.activeReasonType == 'unsuccessful') {
      this.unsuccessfullReason();
    }
    if (this.activeReasonType == 'cancelled') {
      this.cancelledReason();
    }
  }
  totaCount: any;
  listing: any
  countList() {
    this.reason.countCancelunsuccessful().subscribe(
      data => {
        console.log(data);
        this.listing = data.result;
        // this.totaCount = this.listing?.total;
        this.cancelCount = this.listing?.cancelled;
        this.unsuccessfulCount = this.listing?.unsucessfull;
      },
      error => {
        console.error('Error:', error);

      }
    );
  }
  unsuccessfullReason() {
    this.activeReasonType = 'unsuccessful';
    localStorage.setItem("tabName", this.activeReasonType);
    this.isLoading = true;
    this.reason.getReasonUnSuccessfull(this.currentPage).subscribe(
      data => {
        console.log(data);
        this.reasons = data.result.results
        this.reasons?.forEach((element: any, index: number) => {
          element['sNo'] = (index + 1) + (10 * (this.currentPage - 1));
        });
        this.totaCount = data?.result?.count;
        this.isLoading = false;
        if (data.errorMessage === 'Invalid page number') {
          if (this.currentPage > 1) {
            this.unsuccessfullReason()
          }
        }
      },
      error => {
        console.error('Error:', error);
        this.isLoading = false;
      }
    );
  }
  cancelledReason() {
    localStorage.setItem("tabName", this.activeReasonType);
    this.isLoading = true;
    this.reason.getReasonCanceled(this.currentPage).subscribe(
      data => {
        console.log(data);
        this.reasons = data.result.results
        this.reasons?.forEach((element: any, index: number) => {
          element['sNo'] = (index + 1) + (10 * (this.currentPage - 1));
        });
        this.totaCount = data?.result?.count;
        this.isLoading = false;
        if (data.errorMessage === 'Invalid page number') {
          if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.cancelledReason();
          }
        }
      },
      error => {
        console.error('Error:', error);
        this.isLoading = false;
      }
    );
  }
  filterReasons(): void {
    let filtered = this.reasons.filter((r: { category: string; }) => r.category === this.activeReasonType);

    if (this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter((r: { description: string; }) => r.description.toLowerCase().includes(query));
    }

    this.filteredReasons = filtered;
    this.totalPages = Math.ceil(this.filteredReasons.length / this.itemsPerPage);
  }

  onSearchChange(query: string): void {
    this.searchQuery = query;
    if (this.searchQuery.length > 0) {
      this.cross = true;
    }
    else {
      this.cross = false;
    }
    this.search();
  }

  // Reason Modal
  openAddReasonModal(): void {
    this.editingReasonId = null;
    this.reasonForm.reset();
    this.showReasonModal = true;
    document.body.style.overflow = 'hidden';
  }
  handleSubmit(data: any) {
    const formData = new FormData();
    formData.append('reason_text', data.description);
    formData.append('status', data.category);
    this.reason.addReason(formData).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }
        this.loadReasons();
        this.toast.show('success', data?.resultDescription);
      },
      (error) => {
        this.authService.dataError(error);
      }
    );

  }
  openEditReasonModal(reason: any): void {
    this.editingReasonId = reason.id;
    this.reasonForm.patchValue({
      description: reason.reason_text,
      category: reason.status
    });
    this.showReasonModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeReasonModal(): void {
    this.showReasonModal = false;
    document.body.style.overflow = '';
    this.reasonForm.reset();
    this.editingReasonId = null;
  }

  saveReason(): void {
    if (this.reasonForm.invalid) {
      // show all validation errors
      console.log('save id touched')
      this.reasonForm.markAllAsTouched();
      return;
    }

    const formDatas = this.reasonForm.value;

    if (this.editingReasonId) {
      const formData = new FormData();
      formData.append('reason_text', formDatas.description);
      formData.append('status', formDatas.category);
      formData.append('title', '');
      this.reason.reasonEdit(this.editingReasonId, formData).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          this.loadReasons();
          this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Reason updated successfully'));
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
      this.closeReasonModal();
    } else {
      this.handleSubmit(formDatas)
      this.closeReasonModal();
    }
  }


  editReason(reason: Reason): void {
    this.openEditReasonModal(reason);
  }

  async deleteReason(reasonId: any): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Row',
      'Are you sure you want to delete this reason? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      // console.log("FormData Value:", formdata.get('order_ids'));
      this.reason.reasonDelete(reasonId).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          this.countList();
          if (this.activeReasonType == "unsuccessful") {
            this.unsuccessfullReason();
          }
          if (this.activeReasonType == "cancelled") {
            this.cancelledReason();
          }
          this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Reason deleted successfully'));
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
    }
  }

  // Pagination
  changePage(direction: 'prev' | 'next'): void {
    if (direction === 'prev' && this.currentPage > 1) {
      this.currentPage--;
    } else if (direction === 'next' && this.currentPage < this.totalPages) {
      this.currentPage++;
    }
    this.loadReasons();
  }

  getPaginatedReasons(): Reason[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.filteredReasons.slice(start, end);
  }

  getPaginationInfo(): string {
    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(this.currentPage * this.itemsPerPage, this.reasons?.length);
    this.totalPages = Math.ceil(this.totaCount / this.itemsPerPage);
    // return `${start} – ${end} of ${this.filteredReasons.length}`;
    return `Showing ${start} - ${end} of ${this.totaCount} Reasons`;
  }
  showManualPopup = false;

  fromDate: string = '';
  toDate: string = '';

  openManualPopup(): void {
    // this.archiveOrders = 4;
    if (!this.arkiverDates?.archive_start_date && !this.arkiverDates?.archive_end_date) {

      const today = new Date().toISOString().split('T')[0];

      this.fromDate = today;
      this.toDate = today;

    } else {

      this.fromDate = this.arkiverDates.archive_start_date;
      this.toDate = this.arkiverDates.archive_end_date;

    }
    this.showManualPopup = true;
  }
  applyManualArchive() {

    const data = {
      archive_interval: null,
      archive_start_date: this.fromDate,
      archive_end_date: this.toDate
    };

    this.settingService.archivesettingEdit(data).subscribe(
      (res: any) => {
        if (!this.authService.resultCodeError(res)) {
          this.toast.show('success', res?.resultDescription || (typeof res?.result === 'string' ? res?.result : 'Reason added successfully'));
          this.archiveOrders = 4;
          this.closeManualPopup();
        }
      },
      (error) => {
        this.authService.dataError(error);
      }
    );

  }


  closeManualPopup(): void {
    this.showManualPopup = false;
  }

  // applyManualArchive(): void {
  //   if (!this.fromDate || !this.toDate) {
  //     alert('Please select both From and To dates');
  //     return;
  //   }

  //   console.log('From Date:', this.fromDate);
  //   console.log('To Date:', this.toDate);

  //   // 👉 yaha API call / filter logic likhna
  //   // this.getOrdersByDateRange(this.fromDate, this.toDate);

  //   this.closeManualPopup();
  // }
  cross: boolean = false;
  clearText() {
    this.searchQuery = '';
    this.cross = false;
    this.search();
  }
  checkboxItems: any;
  getadmincontol() {
    this.reason.getAdminControll().subscribe(
      data => {
        console.log(data);
        this.checkboxItems = data.result
        this.admins = data.result
      },
      error => {
        console.error('Error:', error);

      }
    );
  }
  arkiverDates: any;
  selectedDates: any;
  require_delivery_signature: any;
  loadAdminSettings() {
    if (this._isRoleName !== 'admin' && this._isRoleName !== 'reciver-admin' && this._isRoleName !== 'receiving-admin') return;

    this.isLoading = true;
    const isReceiving = this._isRoleName === 'reciver-admin' || this._isRoleName === 'receiving-admin';

    forkJoin([
      this.settingService.getSetting(),
      this.settingService.arkiverGetSetting(),
      this.settingService.emailgetSetting(),
      this.settingService.smsgetSetting(),
      this.settingService.getDepartureTime()
    ]).subscribe({
      next: ([generalData, arkiverData, emailData, smsData, deptData]: any[]) => {
        // -------- General Settings --------
        this.settings = generalData.result;
        if (!this.settings || this.settings.length <= 0) {
          isReceiving ? this.recivingpostData() : this.postData();
        } else {
          const s = this.settings[0];
          if (isReceiving) {
            this.pushNotifications.successful = s?.receiving_successful;
            this.pushNotifications.unsuccessful = s?.receiving_unsuccessful;
            this.pushNotifications.cancelled = s?.receiving_cancelled;
            this.clearNotifications = s?.receiving_clear_noti_after;
          } else {
            this.pushNotifications.successful = s?.succssfull;
            this.pushNotifications.unsuccessful = s?.unsuccssfull;
            this.pushNotifications.cancelled = s?.cancelled;
            this.clearNotifications = s?.clear_notifi_month;
          }
          this.receiving_successful = s?.receiving_successful;
          this.receiving_unsuccessful = s?.receiving_unsuccessful;
          this.receiving_cancelled = s?.receiving_cancelled;
          this.receiving_clear_noti_after = s?.receiving_clear_noti_after;
        }

        // -------- Arkiver Settings --------
        this.arkiverDates = arkiverData.data;
        if (!this.arkiverDates || this.arkiverDates.length <= 0) {
          if (!isReceiving) this.arkiverPostData();
        } else {
          if (!this.arkiverDates?.archive_start_date && !this.arkiverDates?.archive_end_date && !this.arkiverDates?.archive_interval) {
            this.archiveOrders = '';
          } else if (this.arkiverDates?.archive_interval) {
            this.archiveOrders = this.arkiverDates.archive_interval;
          } else if (this.arkiverDates?.archive_start_date && this.arkiverDates?.archive_end_date) {
            this.archiveOrders = 4;
            this.fromDate = this.arkiverDates?.archive_start_date;
            this.toDate = this.arkiverDates?.archive_end_date;
          }
        }

        // -------- Email Settings --------
        this.settings = emailData.result;
        if (this.settings && this.settings.length > 0) {
          const e = this.settings[0];
          if (isReceiving) {
            this.emailNotifications.enroute = e?.receiving_enroute;
            this.emailNotifications.shipped = e?.receiving_shipped;
            this.emailNotifications.successful = e?.receiving_successful;
            this.emailNotifications.unsuccessful = e?.receiving_unsuccessful;
            this.emailNotifications.cancelled = e?.receiving_cancelled;
          } else {
            this.emailNotifications.enroute = e?.enroute;
            this.emailNotifications.shipped = e?.shipped;
            this.emailNotifications.successful = e?.successfull;
            this.emailNotifications.unsuccessful = e?.unsuccessfull;
            this.emailNotifications.cancelled = e?.cancelled;
          }
        }

        // -------- SMS Settings --------
        this.settings = smsData.result;
        if (this.settings && this.settings.length > 0) {
          const sms = this.settings[0];
          if (isReceiving) {
            this.smsNotifications.enroute = sms?.receiving_enroute;
            this.smsNotifications.shipped = sms?.receiving_shipped;
          } else {
            this.smsNotifications.enroute = sms?.enroute;
            this.smsNotifications.shipped = sms?.shipped;
          }
        }

        // -------- Departure Time --------
        if (!isReceiving) {
          if (deptData.resultCode === '0') {
            const formData = new FormData();
            const convertedTime = this.convertTo24HourFormat(this.departureTime);
            formData.append('order_start_time', convertedTime);
            formData.append('require_delivery_signature', 'false');
            this.settingService.postDepartureTime(formData).subscribe(
              response => {
                this.departureTime = response.result.order_start_time;
                this.require_delivery_signature = response.result.require_delivery_signature;

              },
              error => console.error('Error updating departure time:', error)
            );
          } else {
            this.departureTime = this.formatTime(deptData.result.order_start_time);
            this.require_delivery_signature = deptData.result.require_delivery_signature;
          }
        }
      },
      error: (err) => {
        console.error('Error loading settings:', err);
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
  postData() {
    if (this._isRoleName == 'superadmin') {
      this.data = {
        sucessfull: 'False',
        unsucessfull: 'False',
        cancelled: 'False',
        month: 1
      }
    }
    else if (this._isRoleName != 'superadmin') {
      this.data = {
        sucessfull: 'False',
        unsucessfull: 'True',
        cancelled: 'False',
        month: 1
      }
    }

    this.settingService.addSetting(this.data).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }
        this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  convertTo24HourFormat(value: string): string {
    if (value && value !== '') {
      let time: any = value;
      let hours = Number(time.match(/^(\d+)/)[1]);
      let minutes = Number(time.match(/:(\d+)/)[1]);
      let AMPM = time.match(/\s(.*)$/)[1];

      // Handle PM and AM logic
      if (AMPM === "PM" && hours < 12) hours += 12;
      if (AMPM === "AM" && hours === 12) hours -= 12;

      // Format hours and minutes with leading zeros if necessary
      let sHours = hours.toString();
      let sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;

      // Return time in 24-hour format (HH:mm:ss)
      return sHours + ":" + sMinutes + ":00";
    } else {
      return '';
    }
  }
  formatTime(time: string): string {
    // Assuming the API returns the time in "HH:mm:ss" 24-hour format
    const [hour, minute] = time.split(':');
    const hour12 = +hour % 12 || 12; // Convert to 12-hour format
    const ampm = +hour >= 12 ? 'PM' : 'AM';
    return `${hour12}:${minute} ${ampm}`;
  }
  arkiverPostData() {
    const data = {
      archive_start_date: '',
      archive_interval: ''
    }
    this.settingService.arkiverAddSetting(data).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        this.toast.show('success', data?.resultDescription || (typeof data?.result === 'string' ? data?.result : 'Settings updated successfully'));
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  getTime(): string {
    return this.departureTime; // Default time if backendTime is not set
  }
  onTimeSelected(selectedTime: string): void {
    if (!this.showadminsblock) {
      this.toast.show('warning', "You don't have permission to edit departure time settings");
      return;
    }
    this.departureTime = selectedTime;
    const convertedTime = this.convertTo24HourFormat(selectedTime);
    this.updateDepartureTime(convertedTime);
  }
  updateDepartureTime(convertedTime: string): void {
    const formData = new FormData();
    formData.append('order_start_time', convertedTime);

    this.settingService.updateDepartureTime(formData).subscribe(
      (response: any) => {
        if (this.authService.resultCodeError(response)) {
          return;
        }
        if (response.resultCode === '1') {
          this.toast.show('success', response?.resultDescription);
        }
      },
      (error: any) => {
        console.error('Error updating time:', error);
      }
    );
  }
  updateSignatureRequirement(convertedTime: string): void {
    const formData = new FormData();
    formData.append('require_delivery_signature', convertedTime);

    this.settingService.updateDepartureTime(formData).subscribe(
      (response: any) => {
        if (this.authService.resultCodeError(response)) {
          return;
        }
        if (response.resultCode === '1') {
          this.toast.show('success', response?.resultDescription);
        }
      },
      (error: any) => {
        console.error('Error updating time:', error);
      }
    );
  }
  reason$!: Observable<object[]>;
  reasonur$!: Observable<object[]>;
  search(): void {
    if (this.activeReasonType == 'cancelled') {
      this.currentPage = 1;
      this.reason.reasonSearchcancelled(this.currentPage, this.searchQuery)
      this.reason$ = this.reason.getreasonscancelled();

      this.reason$.subscribe((data: any) => {
        if (data && data.result && data.result.results) {
          this.reasons = data.result.results;
          this.reasons?.forEach((element: any, index: number) => {
            element['sNo'] = (index + 1) + (10 * (this.currentPage - 1));
          });
          this.totaCount = data?.result?.count;
        }
      });
    }
    if (this.activeReasonType == 'unsuccessful') {
      this.currentPage = 1;
      this.reason.reasonSearchunsuccessful(this.currentPage, this.searchQuery)
      this.reasonur$ = this.reason.getreasonsunsuccessful();

      this.reasonur$.subscribe((data: any) => {
        if (data && data.result && data.result.results) {
          this.reasons = data.result.results
          this.reasons?.forEach((element: any, index: number) => {
            element['sNo'] = (index + 1) + (10 * (this.currentPage - 1));
          });
          this.totaCount = data?.result?.count;
        }
      });
    }
  }
}

